import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {SearchableExclusiveSSIType} from 'constants/ModelTypeConstants';
import {isSearchableSsiType} from 'constants/RegistryConstants';
import {getSearchableExclusiveSsiIcon} from 'constants/SearchableExclusiveSsiTypes';
import {SavedSearch} from 'search/saved-searches/SavedSearchUtil';
import {LEGACY_FONT_PROXIMA_12, LEGACY_FONT_PROXIMA_TITLE} from 'styles/FontConstants';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import Card from 'ui-library/Card';
import {GRAY_DARK, GRAY_DARKER, NEAR_BLACK} from 'ui-library/Colors';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export interface SavedSearchCardProps {
  name: string | JSX.Element;
  metadata?: string;
  onSelect: () => void;
  value?: SavedSearch;
  isDisabled?: boolean;
  sharedIcon?: boolean;
  selected?: boolean;
  dataTestAttrs?: DataTestAttrs;
  savedSearchOptionsMenu?: JSX.Element;
}

export function SavedSearchCard(props: SavedSearchCardProps): JSX.Element {
  // TODO(BNCH-50465): implement favoriting searches

  return (
    <Card
      onSelect={props.onSelect}
      isDisabled={props.isDisabled}
      selected={props.selected}
      dataTestAttrs={props.dataTestAttrs}
      optionsMenu={props.savedSearchOptionsMenu}
    >
      <SavedSearchCardContent {...props} />
    </Card>
  );
}

function SavedSearchCardContent(props: SavedSearchCardProps): JSX.Element {
  return (
    <>
      <BenchlingIcon className={css(styles.typeIcon)} icon={getCorrespondingIcon(props.value!)} />
      <div>
        <div className="u-flex-display">
          <div className={css(styles.nameRow)}>{props.name}</div>
          {props.sharedIcon && <BenchlingIcon className={css(styles.icon)} icon="team" />}
        </div>
        <div className={css(styles.metadataRow)}>{props.metadata}</div>
      </div>
    </>
  );
}

function getCorrespondingIcon(savedSearch: SavedSearch): BenchlingIconName {
  if (!savedSearch.hasAccessToFiltersAndSection) {
    return 'eye-slash';
  }

  const filters = savedSearch.searchParams.filtersJson;
  const typesFilter = filters.find((filter: {key: string}) => filter.key === 'TYPES');
  if (typesFilter && typesFilter.value.length >= 1) {
    const type = typesFilter.value[0];
    return isSearchableSsiType(type)
      ? getSearchableExclusiveSsiIcon(type as SearchableExclusiveSSIType)
      : type;
  }
  return 'save';
}

const styles = StyleSheet.create({
  nameRow: {
    ...LEGACY_FONT_PROXIMA_TITLE,
    color: NEAR_BLACK,
    marginRight: 10,
  },
  metadataRow: {
    ...LEGACY_FONT_PROXIMA_12,
    inline: 'flex',
    color: GRAY_DARKER,
    alignSelf: 'stretch',
  },
  icon: {
    flexShrink: 0,
    fontSize: '16px',
    color: GRAY_DARK,
    marginRight: 10,
  },
  typeIcon: {
    flexShrink: 0,
    fontSize: '16px',
    color: GRAY_DARKER,
    marginRight: 10,
  },
});
